import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types';

function Head({ pageTitle, pageDesc, link }) {

  useEffect(() => {
    console.log("Link to the sitemap: https://www.sugbil.nu/sitemap-01.xml");
  }, []);
  return (
    <Helmet>
      <title>{pageTitle}</title>
      <link rel="canonical" href={`https://www.sugbil.nu/${link}`} />
      <link rel="sitemap" type="application/xml" href="/sitemap-01.xml" />
      <meta name="description" content={pageDesc} />
      <meta property='og:title' content={pageTitle} />
      <meta property='og:description' content={pageDesc} />
    </Helmet>
  )
}

Head.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  pageDesc: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
}

export default Head